import { FC } from "react";
import { Pane, PaneProps } from "evergreen-ui";

import './styles/LoadingShimmer.css';

export const LoadingShimmer: FC<PaneProps> = ({className, ...props}: PaneProps) => {
    return <Pane className={`loading-shimmer ${className}`} {...props} />;
};
